
export const Response = {
    error: false,
    data: {},
    message: '',
    errorsForm: []
}